/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import get from 'lodash/get';
import { Box, Text } from 'sarsaparilla';
import { MONTH_ABREV_DATE_FORMAT } from '../../constants';

function OrderDetailsItinerary({ incrementCheckoutDate, divisions, itinerary }) {
    const renderItinerary = () => {
        return (
            <ul className="mt-1">
                {itinerary.map((item) => {
                    const { division_id, start_date } = item;
                    let { end_date } = item;
                    if (incrementCheckoutDate) {
                        end_date = gnoment(end_date)
                            .clone()
                            .add(1, 'day')
                            .utc()
                            .startOf('day')
                            .format();
                    }

                    return (
                        <li key={`${division_id}-${start_date}`}>
                            <div className="itinerary-dates">
                                {gnoment(start_date)
                                    .utc()
                                    .format(MONTH_ABREV_DATE_FORMAT)}{' '}
                                -{' '}
                                {gnoment(end_date).utc().format(MONTH_ABREV_DATE_FORMAT)}
                            </div>
                            <div className="itinerary-division">
                                {get(divisions, `[${division_id}].name`, null)}
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    };

    if (!itinerary || itinerary.length === 0) {
        return null;
    }

    return (
        <Box className="per-os-itinerary">
            <Text fontWeight="semibold">Trip Itinerary</Text>
            {renderItinerary()}
        </Box>
    );
}

OrderDetailsItinerary.propTypes = {
    divisions: PropTypes.shape({}),
    incrementCheckoutDate: PropTypes.bool,
    itinerary: PropTypes.arrayOf(PropTypes.shape({})),
};

export default OrderDetailsItinerary;
